var _rect, _g, _g2, _line, _line2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWceIdonotWindowToFloorHeight01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 212,
    height: 232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.2023,
    x1: 41.4,
    y1: 60.3,
    x2: 41.4,
    y2: 221.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "37.8,61.3 41.4,55.1 45,61.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "37.8,220.2 41.4,226.4 45,220.2  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M185.9,229.5v-5.3h3.5v0.6h-2.8v1.7h2.8v0.6h-2.8v2.4H185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M190.2,229.5v-5.3h0.7v4.7h2.5v0.6H190.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.4,228.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S194.6,228.7,194.4,228.3z M194.7,226.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C194.9,225.7,194.7,226.2,194.7,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200.5,228.3c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.5-0.7,0.9-1s0.9-0.4,1.4-0.4 c0.5,0,1,0.1,1.4,0.4s0.7,0.6,0.9,1s0.3,0.9,0.3,1.4s-0.1,1-0.3,1.4s-0.5,0.7-0.9,1s-0.9,0.4-1.4,0.4c-0.5,0-1-0.1-1.4-0.4 S200.7,228.7,200.5,228.3z M200.8,226.9c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.7,0.8s0.6,0.3,1,0.3s0.7-0.1,1-0.3 s0.5-0.4,0.7-0.8s0.2-0.7,0.2-1.1c0-0.6-0.2-1.1-0.5-1.6s-0.8-0.6-1.4-0.6c-0.6,0-1.1,0.2-1.4,0.6 C201,225.7,200.8,226.2,200.8,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M206.5,229.5v-5.3h2.1c0.5,0,0.9,0.1,1.2,0.4s0.5,0.7,0.5,1.2c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1l1.4,2.2h-0.8l-1.4-2.1h-1.1v2.1H206.5z  M207.1,226.8h1.4c0.3,0,0.6-0.1,0.8-0.3s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7s-0.5-0.3-0.8-0.3h-1.4V226.8z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 227.3,
    x2: 183,
    y2: 227.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    x1: 53.5,
    y1: 55.1,
    x2: 29.3,
    y2: 55.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWceIdonotWindowToFloorHeight01);
export default __webpack_public_path__ + "static/media/WCE-IDONOT-WindowToFloor-Height-01.d2b9249c468b8cbc076ea3ffb05c9ab4.svg";
export { ForwardRef as ReactComponent };